export enum UserRoleGroup {
  authDashBoard = "dashboard",
  authTeamManagement = "taem-management",
  authDataManagement = "dabt-management",
  authLeadManagement = "lead-management",
  authDabtManagement = "dabt-management",
}
